export interface PriceInput {
  price: number;
  date: string | Date;
  listPrice?: number | null;
}

export interface RichStats {
  current: { price: number; date: string | Date };
  min: { price: number; date: string | Date };
  max: { price: number; date: string | Date };
  startDate: string | Date;
}

export function computeRichStats(prices: PriceInput[]): RichStats {
  const withPrice = prices.filter((p) => p.price != null && p.price > 0);

  if (withPrice.length === 0) {
    const now = new Date().toISOString();
    return {
      current: { price: 0, date: now },
      min: { price: 0, date: now },
      max: { price: 0, date: now },
      startDate: prices[0]?.date ?? now,
    };
  }

  const currentPoint = withPrice[withPrice.length - 1];
  const current = { price: currentPoint.price, date: currentPoint.date };

  let minPoint = withPrice[0];
  let maxPoint = withPrice[0];
  for (const p of withPrice) {
    if (p.price < minPoint.price) minPoint = p;
    if (p.price > maxPoint.price) maxPoint = p;
  }

  return {
    current,
    min: { price: minPoint.price, date: minPoint.date },
    max: { price: maxPoint.price, date: maxPoint.date },
    startDate: prices[0].date,
  };
}
